import React, { useMemo } from "react";

import { boxForwardRef } from "../../../../../helpers/common/Box/Box";
import { Content } from "../../../../Content";
import { createDisplayNameForButtonCellElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCellElement } from "../../utils/getTestId";

import type { BoxComponentWithDefault } from "../../../../../helpers/common/Box/Box";
import type { OmitOfUnion } from "../../../../../types/react";
import type { ContentTextProps } from "../../../../Content/Content/components/Text/ContentText";

export type ButtonCellValueProps = OmitOfUnion<
    ContentTextProps,
    | "textCase"
    | "underline"
    | "lineHeight"
    | "truncateStyle"
    | "asList"
    | "quote"
    | "italic"
>;
const VALUE_TEST_ID = createTestIdForButtonCellElement("value");

export const ButtonCellValue = boxForwardRef<
    BoxComponentWithDefault<"span", ButtonCellValueProps, "className">
>(
    (
        {
            children,
            size = "17",
            view = "secondary",
            customColorsStyles,
            ...props
        },
        ref,
    ) => {
        const viewProps = useMemo(() => {
            if (view === "custom") {
                if (customColorsStyles) return { view, customColorsStyles };
            } else {
                return { view };
            }
        }, [view, customColorsStyles]);

        return children ? (
            <Content.Text
                {...props}
                {...viewProps}
                size={size}
                data-tsid={VALUE_TEST_ID}
                ref={ref}
            >
                {children}
            </Content.Text>
        ) : null;
    },
);

ButtonCellValue.displayName = createDisplayNameForButtonCellElement("Value");

export default ButtonCellValue;
